import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';
import { Reason } from 'services/travelReasonService';

import { Container, Items, Item } from './styles';

interface Props {
  show: boolean;
  value: Reason;
  reasons: Reason[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: Reason) => void;
  onClose: () => void;
  testId?: string;
}

interface MakeItemProps {
  className: string;
  text: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MakeItem = ({ text, ...rest }: MakeItemProps) => <Item {...rest}>{text}</Item>;

const ReasonSelect = ({ show, reasons, selectRef, value, onChange, onClose, testId }: Props) => {
  useOutsideClick(selectRef, onClose);

  const isActive = useCallback((item: Reason) => !!value && item.id === value?.id, [value]);

  const handleItemClick = (item: Reason) => {
    if (item !== value) {
      onChange(item);
    }
    onClose();
  };

  return show ? (
    <Container>
      <Items data-testid={testId ? `${testId}-items` : undefined}>
        {reasons.map((reason, index) => (
          <MakeItem
            key={reason.id}
            className={isActive(reason) ? 'active' : ''}
            text={reason.name}
            onClick={() => handleItemClick(reason)}
            data-testid={index === 0 && testId ? `${testId}-first-item` : undefined}
          />
        ))}
      </Items>
    </Container>
  ) : null;
};

export default ReasonSelect;
